import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { axiosInstance } from "../../AxiosInterceptor/axiosInterceptor";
import { paExtensionQueryCol } from '../../Table/TableQueryColumn';

const initialState = {
    data: {
        runId: '',
        seqNo: '',
        carrier: '',
        accountInput: '',
        groupInput: '',
        memberInput: '',
        gpiInput: '',
    totalCount: 0,
    sortOrder: 'asc',
    columnName: 'Run Date',
    pageSize: 50,
    page: 0,
        tableData: []
    },
    search: true,
    error: false,
    isSearchClicked: false,
    searchTriggered: true,
    loading: true,
    inputError: {
        accountInput: false,
        groupInput: false,
        memberInput: false,
        gpiInput: false,
    }
}

export const getPAExtensionTableData = createAsyncThunk('data/getPAExtensionTableData',
    async (paExtensionData, { rejectWithValue }) => {
        try {
            let queryPAExtension = `query{

        GetPAExtensionDetails(runid:"${paExtensionData.runId}",seq:"${paExtensionData.seqNo}",pageSize:${paExtensionData.pageSize},pageNumber:${paExtensionData.page + 1}${paExtensionData.accountInput ? `,account: "${paExtensionData.accountInput}"` : ""
                }${paExtensionData.groupInput ? `,group: "${paExtensionData.groupInput}"` : ""}${paExtensionData.memberInput ? `,member: "${paExtensionData.memberInput}"` : ""
                }${paExtensionData.gpiInput ? `,gpi: "${paExtensionData.gpiInput}"` : ""} sortOrder:"${paExtensionData.sortOrder}", columnName:"${paExtensionData.columnName}"`;

            if (paExtensionData.carrier !== null || paExtensionData.carrier !== '') {
                if (paExtensionData.carrier.length > 0)
                    queryPAExtension += `,carrier:"${paExtensionData.carrier}"`;
            }
            queryPAExtension += paExtensionQueryCol

            const response = await axiosInstance.post(process.env.REACT_APP_PAEXTENSION_DETAIL,
                JSON.stringify({ query: queryPAExtension, variables: {} })
            );

            if (response.data.errors && response.data.errors.length > 0) {
                const errorMessages = response.data.errors.map(err => err.message).join(', ');
                return rejectWithValue(errorMessages);
            }

            return JSON.stringify(response);
        } catch (err) {
            return rejectWithValue(err.message || 'Unexpected error');
        }
    }
);

const cnsPAExtensionsSlice = createSlice({
    name: 'cnsPAExtensions',
    initialState,
    reducers: {
        currentData: (state, action) => {
            state.data = action.payload
        },
        clearData: (state) => {
            state.data = initialState.data;
            state.search = true;
            state.inputError = initialState.inputError;
            state.error = initialState.error;
        },
        resetData: (state) => {
            state.data = initialState.data;
            state.search = false;
            state.inputError = initialState.inputError;
            state.error = initialState.error;
        },
        updateSearch: (state, action) => {
            state.search = action.payload;
        },
        searchClicked: (state, action) => {
            state.isSearchClicked = action.payload;
            state.error = initialState.error;
        },
        clearTable: (state, action) => {
            state.isSearchClicked = action.payload;
        },
        searchTriggered: (state, action) => {
            state.searchTriggered = action.payload;
        },
        updateInputError: (state, action) => {
            state.inputError = action.payload
        },
        resetError: (state, action) => {
            state.inputError = initialState.inputError;
        },
        resetToaster: (state, action) => {
            state.error = initialState.error;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getPAExtensionTableData.pending, (state) => {
                state.loading = true;
                state.error = false;
            })
            .addCase(getPAExtensionTableData.fulfilled, (state, action) => {
                const response = JSON.parse(action.payload);
                state.error = false;
                state.loading = false;
                state.data.totalCount = response.data.data.GetPAExtensionDetails.totalCount;
                state.data.tableData = response.data.data.GetPAExtensionDetails.data;
            })
            .addCase(getPAExtensionTableData.rejected, (state, action) => {
                state.loading = false;
                state.error = true;
            })
    }
})

export const { currentData, clearData, updateSearch, searchClicked,
    clearTable, searchTriggered, updateInputError, resetError, resetToaster } = cnsPAExtensionsSlice.actions;
export default cnsPAExtensionsSlice.reducer;